import CircularProgress from '@mui/material/CircularProgress';
import { forwardRef } from 'react';

export type LoaderProps = {
  size?: number;
  thickness?: number;
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
};

/** Thin wrapper around MUI CircularProgress for design-system usage. */
export const Loader = forwardRef<HTMLSpanElement, LoaderProps>(function Loader(
  { size = 40, thickness = 3.6, color = 'primary' },
  ref
) {
  return <CircularProgress ref={ref} size={size} thickness={thickness} color={color} />;
});

